import { getFlowKey } from '../routing/getFlowKey';
export const CONTROL = 'control';
export const VARIANT = 'variant';
export const VARIANT_A = 'variant_a';
export const VARIANT_B = 'variant_b';
export const VARIANT_C = 'variant_c';
export const VARIANT_D = 'variant_d';
export const enrollOnFlow = flows => {
  return flows.includes(getFlowKey());
};